import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'socialPictures';
  const widgetOpts = socialPicturesOpts;
  const $widget = $(`#${widgetName}`);

  const wrapContainerClass = 'social-pictures-wrapper';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: 'all',
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 5,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomCards(data.items);
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const $cardItem = $(this);
      const { URL, Title } = widgetData[x];

      $cardItem.find('.image-container').wrap('<div class="img-wrapper"></div>');
      $cardItem.attr('aria-label', Title);
      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL) {
        $cardItem.addClass('empty-card').removeAttr('href');
      }

      $cardItem.attr({
        'data-aos': 'fade-left',
        'data-aos-easing': 'ease-in-out',
        'data-aos-duration': '800',
        'data-aos-delay': (x + 1) * 150,
        'data-aos-once': 'true',
        'data-aos-offset': '100',
      });
    });
  }
}
